module.exports = __webpack_public_path__ + "img/kefu001.390616a8.jpg";